export const actionTypes: any = {
  // GET
  GET_AUCTION_ENQUIRY_START: 'GET_AUCTION_ENQUIRY_START',
  GET_AUCTION_ENQUIRY_SUCCESS: 'GET_AUCTION_ENQUIRY_SUCCESS',
  GET_AUCTION_ENQUIRY_FINISH: 'GET_AUCTION_ENQUIRY_FINISH',
}
